import { computed } from '@vue/composition-api'
import store from '@/store'

export default function useCalendarSidebar() {
  // ------------------------------------------------
  // organizationUsers
  // ------------------------------------------------
  const organizationUsers = computed(() => store.state.organization.organizationUsers)
  // const me = computed(() => store.getters['auth/me'])

  // ------------------------------------------------
  // selectedCalendars
  // ------------------------------------------------
  const selectedCalendars = computed({
    get: () => store.getters['calendar/getSelectedCalendars'],
    set: val => {
      store.commit('calendar/SET_SELECTED_CALENDARS', val)
    },
  })

  // ------------------------------------------------
  // checkAll
  // ------------------------------------------------
  const checkAll = computed({
    /*
      GET: Return boolean `true` => if length of options matches length of selected filters => Length matches when all events are selected
      SET: If value is `true` => then add all available options in selected filters => Select All
           Else if => all filters are selected (by checking length of both array) => Empty Selected array  => Deselect All
    */
    get: () => selectedCalendars.value.length === organizationUsers.value.length,
    set: val => {
      if (val) {
        selectedCalendars.value = organizationUsers.value.map(u => u.calendar.id)
      } else if (selectedCalendars.value.length === organizationUsers.value.length) {
        selectedCalendars.value = []
      }
    },
  })

  const activateEditingSidebar = () => {
    store.dispatch('calendarEventEditing/activateEditing')
  }

  return {
    organizationUsers,
    selectedCalendars,
    checkAll,

    activateEditingSidebar,
  }
}
